<template>
   <v-container>
     <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <h1>Customize with CSS</h1>
            </v-col>
            <v-col class="flex-end" cols="6">
              <v-btn
                @click="updateCss"
                :disabled="!newCssToBeUpdated"
                variant="outlined"
                rounded
                class="theme-main-color"
              >
                Update cashier
                <v-icon class="pl-2">mdi-reload</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <p>All type of styling you want is achievable with custom CSS.</p>
          <div class="css-editor-wrapper">
            <prism-editor
              class="css-editor"
              v-model="code"
              :highlight="highlighter"
            ></prism-editor>
          </div>
        </v-col>
     </v-row>
   </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css'
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-css'
import 'prismjs/themes/prism-tomorrow.css'

export default {
  name: 'Css-customization',
  components: {
    PrismEditor
  },
  data: () => ({
    code: '/* Add your custom CSS here */',
    newCssToBeUpdated: false,
    newCss: ''
  }),
  watch: {
    code () {
      this.newCssToBeUpdated = Boolean(this.code)
    }
  },
  methods: {
    ...mapMutations([
      'updateSpecificCssPreset',
      'reloadCashierMutation'
    ]),
    highlighter (code) {
      return highlight(code, languages.css)
    },
    updateCss () {
      const cssObject = {
        css: this.code,
        preset: this.preset
      }
      this.updateSpecificCssPreset(cssObject)
      this.reloadCashierMutation()
      this.newCssToBeUpdated = false
    }
  },
  computed: {
    ...mapState({
      theme: ({ theme }) => theme.theme,
      customCss: ({ theme }) => theme.customCss,
      preset: ({ config }) => config.preset
    })
  },
  created () {
    const customCss = this.customCss && this.customCss[this.preset]
    if (customCss) {
      this.code = customCss
    }
  },
  mounted () {
    // Ensure code is set after component is mounted
    const customCss = this.customCss && this.customCss[this.preset]
    if (customCss && customCss !== this.code) {
      this.code = customCss
    }
  }
}
</script>

<style>
.flex-end {
  display:flex;
  justify-content:flex-end
}
.css-editor-wrapper {
  margin-top: 20px;
  width: 100%;
  height: 500px;
  background: #2d2d2d;
  border-radius: 4px;
  overflow: hidden;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 16px;
  line-height: 1.5 !important;
}
.css-editor {
  height: 500px;
  width: 100%;
  background: #2d2d2d;
}
.css-editor .prism-editor__editor {
  color: #ccc;
  font: inherit;
  line-height: inherit;
}

.css-editor .prism-editor__textarea {
  font: inherit;
  line-height: inherit;
}
</style>
